//ProgressInquiryService.ts

import { axiosRequest } from '../AxiosService';
import { ProgressInquiryResponseList,ProgressInquiryResponse } from '../../type/response/ProgressInquiryResponse';
import { ProgressInquiryType } from '../../pages/HomePage/Components/Progress/ProgressInquiryType';

/**
 * ホームページ用の進捗照会データを取得し、表示用の形式に変換して返す
 * @returns 進捗照会一覧データ、取得失敗時は空配列
 */
export const getProgressInquiries = async (): Promise<ProgressInquiryType[]> => {
    try {
        const response = await axiosRequest<ProgressInquiryResponseList>(
          "/progressInquiries", 
          "GET",
        );

        // 取得したデータのフォーマット化
    const formattedProgressInquiries: ProgressInquiryType[] = response.map((progressInquiryResponse: ProgressInquiryResponse) => {
        const formattedProgressInquiry: ProgressInquiryType = {
          id: progressInquiryResponse.applicationEntry.id,
          applicantName: `${progressInquiryResponse.user.lastName}${progressInquiryResponse.user.firstName}`,
          applicationNumber: progressInquiryResponse.applicationEntry.number,
          submittedAt: progressInquiryResponse.applicationEntry.submittedAt,
          applicationType: progressInquiryResponse.applicationType.name,
          applicantId:progressInquiryResponse.user.id,
          applicationName: progressInquiryResponse.application.name,
          description:progressInquiryResponse.application.description,
          applicationStatus: progressInquiryResponse.applicationEntry.status,
          activities: progressInquiryResponse.activities.map((act) => ({
            id: act.id,
            status: act.status,
            activityName: act.applicationActivity.activityName,
            endAt: act.endAt,
            order: act.applicationActivity.activityOrder
          })),
        };
  
        return formattedProgressInquiry;
      });
  
      return formattedProgressInquiries;
  
    } catch (error) {
      console.error("進捗照会データの取得・整形に失敗しました:", error);
      return []; 
    }
  };